/**
 * Strips numbering/lettering from lists.
 *
 * @param {string} string
 * */
const stripNumberingFromString = (string: string | undefined): string => {
    return string ? string.replace(/^([a-zA-Z0-9]{1,2}\.)/, '').trim() : '';
};

export { stripNumberingFromString };
